import { AssistantBase, Config } from '@langchain/langgraph-sdk';

import { create } from 'zustand';

export enum AssistantModalState {
  OPEN = 'open',
  CLOSED = 'closed',
  NEW = 'new',
}

interface AssistantState {
  assistantModalState: AssistantModalState;
  nodeConfigurationModalOpen?: string;
  openingAssistantFromNodeConfiguration?: string;
  selectedAssistantId?: string;
  activeAssistantId?: string;
  config?: Config;
  currentSelectedVersion?: number;
  stagedAssistant?: Partial<AssistantBase>;
}

interface AssistantStateActions {
  setAssistantModalState: (assistantModalState: AssistantModalState) => void;
  setOpeningAssistantFromNodeConfiguration: (
    openingAssistantFromNodeConfiguration: string | undefined
  ) => void;
  setNodeConfigurationModalOpen: (
    nodeConfigurationModalOpen: string | undefined
  ) => void;
  setSelectedAssistantId: (selectedAssistantId: string | undefined) => void;
  setActiveAssistantId: (activeAssistantId: string | undefined) => void;
  setConfig: (config: Config) => void;
  setCurrentSelectedVersion: (
    currentSelectedVersion: number | undefined
  ) => void;
  setStagedAssistant: (
    stagedAssistant: Partial<AssistantBase> | undefined
  ) => void;
}

export const useAssistantStore = create<AssistantState & AssistantStateActions>(
  (set) => ({
    assistantModalState: AssistantModalState.CLOSED,
    setAssistantModalState: (assistantModalState: AssistantModalState) => {
      set(() => ({
        assistantModalState,
      }));
    },
    openingAssistantFromNodeConfiguration: undefined,
    setOpeningAssistantFromNodeConfiguration: (
      openingAssistantFromNodeConfiguration: string | undefined
    ) => {
      set(() => ({
        openingAssistantFromNodeConfiguration,
      }));
    },
    nodeConfigurationModalOpen: undefined,
    setNodeConfigurationModalOpen: (
      nodeConfigurationModalOpen: string | undefined
    ) => {
      set(() => ({
        nodeConfigurationModalOpen,
      }));
    },
    selectedAssistantId: undefined,
    setSelectedAssistantId: (selectedAssistantId: string | undefined) => {
      set(() => ({
        selectedAssistantId,
      }));
    },
    activeAssistantId: undefined,
    setActiveAssistantId: (activeAssistantId: string | undefined) => {
      set(() => ({
        activeAssistantId,
      }));
    },
    config: undefined,
    setConfig: (config: Config) => {
      set(() => ({
        config,
      }));
    },
    currentSelectedVersion: undefined,
    setCurrentSelectedVersion: (currentSelectedVersion: number | undefined) => {
      set(() => ({
        currentSelectedVersion,
      }));
    },
    stagedAssistant: undefined,
    setStagedAssistant: (
      stagedAssistant: Partial<AssistantBase> | undefined
    ) => {
      set(() => ({
        stagedAssistant,
      }));
    },
  })
);
